import { useRouter } from 'vue-router'
import type { App, Plugin } from 'vue'
import { i18n } from '@/modules/i18n'
import type { ChatHubServiceType } from '@/modules/signalr-hubs/chat-hub'
import { useChatHubService } from '@/modules/signalr-hubs/chat-hub'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

declare module 'pinia' {
  export interface PiniaCustomProperties {
    router: ReturnType<typeof useRouter>
    t: ReturnType<typeof useI18n>
    toast: ReturnType<typeof useToast>
    chatHubService: ChatHubServiceType
  }
}

const pinia = createPinia()

pinia.use(({ store }) => {
  store.chatHubService = useChatHubService()

  store.router = useRouter()
  store.t = i18n.global as unknown as ReturnType<typeof useI18n>
  store.toast = useToast()
})
pinia.use(piniaPluginPersistedstate)

export default {
  install(app: App) {
    app.use(pinia)
  },
} as Plugin
